import { Select } from "./select.model";

export class SelectCode extends Select {
  code: string | null = null;
}
